/**
 * KISISEL VERI MASKELEME — platform yonetimi ekranlari.
 *
 * `admin-` oneki bir dosya sahipligi kurali (bkz. src/lib/task-*.ts): bu
 * yardimcilar yalniz `src/features/admin` tarafindan kullaniliyor.
 *
 * NEDEN VAR: platform yonetimi BASKA INSANLARIN kisisel verisini gosteren tek
 * bolge. Bir listede yirmi kisinin e-postasi ve telefonu acik dururken ekran
 * goruntusu, omuz ustu bakis ve ekran paylasimi bunlarin hepsini birden disari
 * verir; oysa yoneticinin listeye bakarken ihtiyaci olan sey genellikle YALNIZ
 * KIM oldugu. Bu yuzden iletisim alanlari VARSAYILAN OLARAK maskeli cizilir ve
 * gorunur kilmak icin bilincli bir hareket (ekrandaki "iletisim bilgilerini
 * goster" anahtari) gerekir.
 *
 * Maskeleme bir GUVENLIK onlemi DEGIL — veri yine de tarayiciya gelmis
 * durumda. Amac, gereksiz yere BAKILMASINI zorlastirmak; sunucu projeksiyonunun
 * dar tutulmasi (TC kimlik hic gelmiyor, sifre hic secilmiyor) asil onlem.
 */

/** Maskeleme karakteri. Yildiz degil: yildiz "zorunlu alan" ile karisiyor. */
const DOT = '•';

const dots = (count: number): string => DOT.repeat(Math.max(count, 1));

/**
 * `buroadmin@demo.com` -> `bu•••••••@demo.com`
 *
 * ALAN ADI ACIK BIRAKILIR: yoneticinin ayirt etmesi gereken sey cogu zaman
 * kurumsal alan adi (`@demo.com` ile `@gmail.com`), kisinin adi degil.
 */
export const maskEmail = (email: string): string => {
  const value = email.trim();
  if (value.length === 0) return '';
  const at = value.lastIndexOf('@');
  // '@' yoksa (bozuk kayit) tamami maskelenir — yarim tanidik bir dize
  // gostermek, gostermemekten daha kotu.
  if (at <= 0) return dots(value.length);
  const local = value.slice(0, at);
  const domain = value.slice(at);
  const keep = local.length <= 2 ? 1 : 2;
  return `${local.slice(0, keep)}${dots(local.length - keep)}${domain}`;
};

/**
 * `5559000004` -> `555•••••04`
 *
 * Bas ve son basamaklar birakilir: operator kodu ve son iki hane, "aradigim
 * numara bu mu" sorusuna maskeliyken de cevap verebilen tek parca.
 */
export const maskPhone = (phone: string): string => {
  const value = phone.trim();
  if (value.length === 0) return '';
  if (value.length <= 5) return dots(value.length);
  return `${value.slice(0, 3)}${dots(value.length - 5)}${value.slice(-2)}`;
};

/** Anahtar kapaliysa maskeler, aciksa oldugu gibi birakir. */
export const revealOrMask = (
  value: string,
  reveal: boolean,
  mask: (input: string) => string,
): string => (reveal ? value : mask(value));
